import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';

import messages from '../../../locale/jsonMessages';
import { FORM_LIMITS } from '../../../helpers/inspectionForm';
import StarsInput from '../StarsInput/StarsInput';
import s from '../Inspection.css';

// Review block of the check-out (R11): stars + text, sent through the existing review module by the page (separate call).
export function InspectionReview({ title, hint, rating, content, onRating, onContent, required, errorKey, id }) {
  const { formatMessage } = useIntl();
  return (
    <section className={s.card}>
      <h3 className={s.cardTitle}>{title}{required && <span className={s.required} aria-hidden="true"> *</span>}</h3>
      <p className={s.cardHint}>{hint}</p>
      <div className={s.field}>
        <span className={s.fieldLabel}>{formatMessage(messages.inspReviewRating)}</span>
        <StarsInput value={rating} onChange={onRating} />
      </div>
      <div className={s.field}>
        <label className={s.fieldLabel} htmlFor={id}>{formatMessage(messages.inspReviewText)}</label>
        <textarea id={id} className={cx(s.textarea, errorKey && s.inputError)} value={content} maxLength={FORM_LIMITS.comment}
          placeholder={formatMessage(messages.inspReviewPlaceholder)} aria-invalid={errorKey ? 'true' : undefined}
          onChange={(event) => onContent(event.target.value)} />
        <p className={s.charCount}>{content.length}/{FORM_LIMITS.comment}</p>
        {errorKey && <p className={s.errorText} role="alert">{formatMessage(messages[errorKey])}</p>}
      </div>
    </section>
  );
}

InspectionReview.propTypes = {
  title: PropTypes.node, hint: PropTypes.node, rating: PropTypes.number, content: PropTypes.string,
  onRating: PropTypes.func, onContent: PropTypes.func, required: PropTypes.bool, errorKey: PropTypes.string, id: PropTypes.string
};
InspectionReview.defaultProps = { rating: 0, content: '', id: 'inspection-review' };

export default withStyles(s)(InspectionReview);
